const DependenciesList = [
    {
        "sentry.occurrence": [
            "sentry.analysis.profile",
            "sentry.alarm.sign2",
            "sentry.analysis.proximity",
            "sentry.analysis.network",
            "sentry.occurrence.localpublic",
            "sentry.occurrence.localinteligence",
            "sentry.occurrence.mygroups",
            "sentry.occurrence.myuser",
            "sentry.occurrence.createshared",
            "sentry.occurrence.receiveshared",
            "sentry.occurrence.delete.data",
            "sentry.occurrence.alarm.scheduling",
            "sentry.occurrence.tracking",
            "sentry.occurrence.mobile",
            "sentry.occurrence.mark",
            "sentry.occurrence.export.result",
            "sentry.occurrence.print",
            "sentry.occurrence.show.filed",
            "sentry.analysis.associative",
            "sentry.clone",
            "sentry.report.occurrence.vehicle",
            "sentry.occurrence.admin",
        ]
    },
    {
        "sentry.passage.search": [
            "sentry.analysis.profile",
            "sentry.alarm.sign2",
            "sentry.analysis.proximity",
            "sentry.analysis.network",
            "sentry.analysis.intersection",
            "sentry.passage.search.filter",
            "sentry.passage.search.report",
            "sentry.analysis.associative",
            "sentry.passage.export",
            "sentry.passage.search.limit.time",
            "sentry.clone",
            "sentry.passage.label"
        ]
    },
    {
        "sentry.analysis.proximity": [
            "sentry.alarm.sign2"
        ]
    },
    {
        "sentry.analysis.associative": [
            "sentry.alarm.sign2"
        ]
    },
    {
        "sentry.reference.individual": [
            "sentry.alarm.sign2",
            "sentry.analysis.network"
        ]
    },
    {
        "sentry.reference.vehicle": [
            "sentry.alarm.sign2",
            "sentry.analysis.network"
        ]
    },
    {
        "sentry.bogcm.view.all": [
            "sentry.bogcm.edit.all",
            "sentry.bogcm.review.all",
            "sentry.bogcm.evaluation.all",
        ]
    },
    {
        "sentry.bogcm.view.subordinates": [
            "sentry.bogcm.edit.subordinates",
            "sentry.bogcm.review.subordinates",
            "sentry.bogcm.evaluation.subordinates",
        ]
    },
    {
        "sentry.occurrence.tracking": [
            "sentry.adr.monitoring"
        ]
    },
    {
        "sentry.adr.code": [
            "sentry.adr.monitoring",
            "sentry.adr.code.search"
        ]
    },
    {
        "sentry.adr.code.search": [
            "sentry.adr.monitoring"
        ]
    },
    {
        "sentry.bogcm.view.my": [
            "sentry.bogcm.view.subordinates",
        ]
    },
    {
        "sentry.bogcm.view.my": [
            "sentry.bogcm.edit.my",
        ]
    },
    {
        "sentry.bogcm.edit.my": [
            "sentry.bogcm.edit.subordinates",
        ]
    },
    {
        "sentry.dispatch.garrison_leader": [
            "sentry.bogcm.view.subordinates",
            "sentry.bogcm.edit.subordinates",
            "sentry.bogcm.review.subordinates",
            "sentry.bogcm.evaluation.subordinates",
        ]
    },

    {
        "sentry.bogcm.web": [
            "sentry.bogcm.reject",
            "sentry.bogcm.rectify",
            "sentry.bogcm.add_other_documents",
            "sentry.bogcm.invalidate",
        ]
    },
    {
        "sentry.dispatch.garrison.web": [
            "sentry.dispatch.dispatch"
        ]
    },
    {
        "sentry.dispatch.garrison.mobile": [
            "sentry.dispatch.attendance.mobile",
        ]
    },
    {
      "sentry.dispatch.contingent": [
          "sentry.dispatch.garrison.mobile",
          "sentry.dispatch.mygarrison"
      ]
    },
    {
        "sentry.dispatch": [
            "sentry.dispatch.admin",
            "sentry.dispatch.attendance.web",
            "sentry.dispatch.garrison.web",
            "sentry.dispatch.task.web",
            "sentry.dispatch.retroactive",
            "sentry.dispatch.garrison.schedule",
            "sentry.dispatch.activity",
            "sentry.dispatch.activity_subordinates",
            "sentry.dispatch.attendance_visualization",
            "sentry.dispatch.attendance_schedule",
            "sentry.dispatch.attendance.schedule.calendar",
            "sentry.dispatch.mygarrison",
            "sentry.dispatch.attendance.app_allow_view_call",
            "sentry.dispatch.duty_information"
        ]
    },
    {
        "sentry.dispatch.mobile.view_all_garrisons": [
            "sentry.dispatch.mobile.schedule_all_garrisons"
        ]
    },
    {
        "sentry.contactid": [
            "sentry.contactid.admin"
        ]
    },
    {
        "sentry.occurrence.localpublic": [
            "sentry.report.occurrence.vehicle",
            "sentry.occurrence.admin"
        ]
    },
    {
        "sentry.occurrence.localinteligence": [
            "sentry.report.occurrence.vehicle",
            "sentry.occurrence.admin"
        ]
    },
    {
        "sentry.occurrence.mygroups": [
            "sentry.report.occurrence.vehicle",
            "sentry.occurrence.admin"
        ]
    },
    {
        "sentry.occurrence.myuser": [
            "sentry.report.occurrence.vehicle",
            "sentry.occurrence.admin"
        ]
    },
    {
        "sentry.analysis.network": [
            "sentry.alarm.sign2"
        ]
    },
    {
        "sentry.gis": [
            "sentry.dispatch.garrison.vehicle"
        ]
    },
    {
        "sentry.encounter":  [
            "sentry.analysis.network",
            "sentry.encounter.edit"
        ]
    },
    {
        "sentry.dispatch.dispatch": [
            "sentry.dispatch.attendance.app_allow_view_call"
        ]
    },
    {
        "sentry.dispatch.garrison.vehicle": [
            "sentry.dispatch.attendance.app_allow_view_call"
        ]
    },

    {
        "sentry.alarm.sign1": [
            "sentry.inactivate.alarm",
            "sentry.manage.alarm.configurations"
        ]
    },

    {
        "sentry.alarm.sign2": [
            "sentry.manage.alarm.configurations"
        ]
    },


    {
        "sentry.alarm.sign1.view": [
            "sentry.alarm.sign1"
        ]
    },

    { "sentry.occurrence.createshared": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.receiveshared": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.show.filed": [ "sentry.occurrence.admin", "sentry.occurrence.receiveshared" ] },
    { "sentry.occurrence.delete.data": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.alarm.scheduling": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.mark": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.print": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.export.result": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.tracking": [ "sentry.occurrence.admin" ] },
    { "sentry.occurrence.mobile": [ "sentry.occurrence.admin" ] },

    { "sentry.erp.fleet": [ "sentry.erp.fleet.supply.edit" ] },

    {"sentry.sos.manage.events": ["sentry.sos.attachs.show"] },

];

export default DependenciesList
